import React from "react";
import { Helmet } from "react-helmet";
import ReactWhatsapp from "react-whatsapp";

function Training() {
  return (
    <div>
      <Helmet>
        <title>
          Professional Fire Safety Training | Keep Your Workplace Safe
        </title>

        <meta
          name="description"
          content="Experienced Professionals: Our trainers are highly experienced professionals with a wealth of knowledge and expertise in fire safety."
        />
        <meta
          name="keyword"
          content="fire and safety course,safety training,training courses ,fire training ,fire safety course ,fire safety training ,safety course ,in service training,safety, training courses , training services  ,fire course  ,fire and,safety training,safety train"
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:1, max-video-preview:1"
        />
        <link
          rel="canonical"
          href="https://www.therapidhire.com/training"
          data-react-helmet="true"
        ></link>

        <meta
          name="fb:app_id"
          content="1369882117133030"
          data-react-helmet="true"
        />
        <meta
          property="og:url"
          content="https://www.therapidhire.com/training"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Professional Fire Safety Training"
        />
        <meta
          property="og:description"
          content="Experienced Professionals: Our trainers are highly experienced professionals."
        />
        <meta
          property="og:image"
          content="https://www.therapidhire.com/images/Firesafety4.jpg"
        />
        <meta property="og:image:type" content="image/jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="fire safety" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@therapidhire_" />
        <meta
          property="twitter:url"
          content="https://www.therapidhire.com/training"
        />
        <meta
          name="twitter:title"
          content="Professional Fire Safety Training"
        />
        <meta
          name="twitter:description"
          content="Experienced Professionals: Our trainers are highly experienced professionals"
        />
        <meta
          name="twitter:image"
          content="https://www.therapidhire.com/images/Firesafety4.jpg"
        />
      </Helmet>
      <div
        id="rs-slider"
        className="rs-slider slider3 rs-slider-style3"
        style={{ position: "relative", overflow: "hidden" }}
      >
        <div className="bend niceties">
          <img src="images/Firesafety4.jpg" alt="FireSafety" title="" />
        </div>
      </div>
      <div className="row text-center">
        <div class="">
          <h2
            className="fs-3 h3 block-title text-center font-weight-bold pt-3"
            style={{ fontWeight: "600" }}
          >
            Fire Service Motto <br />
            <h3 style={{ color: "red" }}>"WE SERVE TO SAVE"</h3>
          </h2>
          <h2
            className="fs-4 block-title text-center"
            style={{ fontWeight: "600" }}
          >
            "Sweat, Train, Save. The more we Sweat in training, the less we'll
            bled if a real fire"
          </h2>
        </div>
      </div>

      <div className="row pt-4 pb-5">
        <div class="col-md-6">
          <div className="" style={{ paddingLeft: "80px" }}>
            <h2
              className="fa fa-arrow-right fs-1 h3 block-title   font-weight-bold"
              style={{ fontWeight: "700", color: "#FF4500" }}
            >
              Training Modules
            </h2>
            &nbsp;&nbsp;
            <ul class="fa-ul">
              <li className="fs-5 px-2 mt-5">
                <span class="fa-li fireright">
                  <i class="fa fa-check"></i>
                </span>{" "}
                Basic Fire Fighting Training
              </li>
              <ul
                className="ps-5"
                style={{ listStyle: "circle", fontWeight: "500" }}
              >
                <li> Top Level Management</li>
                <li>Middle Level Management</li>
                <li>Low Level Management</li>
              </ul>
              <li className="fs-5 px-2">
                <span class="fa-li fireright">
                  <i class="fa fa-check"></i>
                </span>{" "}
                Advanced Fire Fighting Training & Rescue Training
              </li>
              <li className="fs-5 px-2">
                <span class="fa-li fireright">
                  <i class="fa fa-check"></i>
                </span>
                Auxillary Fire Squad Training
              </li>
              <li className="fs-5 px-2">
                <span class="fa-li fireright">
                  <i class="fa fa-check"></i>
                </span>
                Fire Safety Awareness
              </li>
              <li className="fs-5 px-2">
                <span class="fa-li fireright">
                  <i class="fa fa-check"></i>
                </span>
                Fire Marshal Training
              </li>
              <li className="fs-5 px-2">
                <span class="fa-li fireright">
                  <i class="fa fa-check"></i>
                </span>
                Fire Extinguisher Training
              </li>

              <li className="fs-5 px-2">
                <span class="fa-li fireright">
                  <i class="fa fa-check"></i>
                </span>
                Bespoke Training
              </li>
              <li className="fs-5 px-2">
                <span class="fa-li fireright">
                  <i class="fa fa-check"></i>
                </span>
                Fire Mockdrill & Evacuation drill
              </li>
            </ul>
          </div>
        </div>0
        <div class="col-md-6">
          <img src="images/trainig1.png" alt="trainig1" title="" />
        </div>
      </div>

      <div className="py-5">
        <div className="container">
          <div class="row">
            <div class="cardimges col-sm-6 col-md-4 mb-3">
              <img
                src="images/Firetrainig4.jpg"
                alt="Firetrainig4"
                class="fluid img-thumbnail"
              />
            </div>
            <div class=" cardimges col-sm-6 col-md-4 mb-3">
              <img
                src="images/Firetrainig2.jpg
              "
                alt="Firetrainig2"
                class="fluid img-thumbnail"
              />
            </div>
            <div class="cardimges col-sm-6 col-md-4 mb-3">
              <img
                src="images/Firetrainig3.jpg
              "
                alt="Firetrainig2"
                oi
                class="fluid img-thumbnail"
              />
            </div>
            <div class="cardimges col-sm-6 col-md-4 mb-3">
              <img
                src="images/Firetrainig4.png"
                alt="Firetrainig4"
                class="fluid img-thumbnail"
              />
            </div>
            <div class=" cardimges col-sm-6 col-md-4 mb-3">
              <img
                src="images/Firetrainig7.png
              "
                alt="Firetrainig5"
                class="fluid img-thumbnail"
              />
            </div>
            <div class="cardimges col-sm-6 col-md-4 mb-3">
              <img
                src="images/Firetrainig6.png
              "
                alt="Gallary3"
                class="fluid img-thumbnail"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid py-5">
        <div className="">
          <h2
            className="fa fa-arrow-right fs-1 h3 py-3 block-title font-weight-bold"
            style={{ fontWeight: "700", color: "#FF4500" }}
          >
            Why Choose Us?
          </h2>
        </div>

        <div className="py-2 ps-1">
          <ul
            className="justify-content-start px-5 pb-5"
            style={{ listStyle: "circle" }}
          >
            <li>
              Experienced Professionals: Our trainers are highly experienced
              professionals with a wealth of knowledge and expertise in fire
              safety.
            </li>
            <li>
              Tailored Training: We understand that every client is different,
              and we tailor our training programmes to meet their unique needs.
            </li>
            <li>
              Comprehensive Training: Our courses cover all aspects of fire
              safety, from prevention to response.
            </li>
            <li>
              Flexible Schedule: We offer flexible training schedules to
              minimize disruption to your business or organization.
            </li>
            <li>
              Competitive Pricing: We offer competitive pricing for all our
              training courses, without compromising on quality.
            </li>
          </ul>
        </div>
      </div>
      <div class="floating_btn">
        <a target="_blank" href="https://wa.me/">
          <div class="contact_icon">
            <ReactWhatsapp
              number="+91-9907657026"
              message="Hello, May I Help You !"
              class="whatsappbuttn"
            >
              {" "}
              <i className="fa fa-whatsapp"></i>
            </ReactWhatsapp>
          </div>
        </a>
        <p class="text_icon">Chat with us</p>
      </div>
    </div>
  );
}

export default Training;
